<bp-hl-area-container name="Vegetationsaufnahme">
	<div class="touch-form">
		<!-- Groesse der Aufnahmeflaeche (nur Grube) -->
		@if (isG()) {
			<div class="form-section-header">Aufnahmefläche</div>
			<div class="form-row">
				<div class="form-label-cell">Größe der Aufnahmefläche</div>
				<div class="form-input-cell full-width">
					<wd-text-input name="GroesseDerAufnahmeFlaeche" [(model)]="data.bodenvegetation.groesseDerAufnahmeFlaeche"></wd-text-input>
				</div>
			</div>
		}
		<!-- Schichtanteile Section – bleibt beim Scrollen oben angeheftet -->
		<div class="schicht-sticky">
			<div class="form-section-header">Schichtanteile</div>
			<div class="form-row">
				<div class="form-input-cell multi equal-width">
					<div *ngFor="let sch of schichten()" class="schicht-summary">
						<span class="schicht-label">{{schichtLabel(sch)}}</span>
						<span class="schicht-value">{{data.bodenvegetation.aufnahme.schichtAnteile[sch] ?? '–'}}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Vegetationstabelle Section -->
		<div class="form-section-header">Vegetation</div>
		<div class="vegetation-scroll">
		<table class="table table-sm table-striped table-hover vegetation-table">
			<thead>
				<tr>
					<th class="col-schicht">Schicht</th>
					<th class="col-vegetation">Vegetation</th>
					<th class="col-prozent text-right">%</th>
					<th class="col-loeschen"></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of data.bodenvegetation.aufnahme.vegetationen; let i = index">
					<td>
						<wd-list-input name="Vegetationsschicht[{{i}}]" [(model)]="row.schicht" (modelChange)="onVegetationChanged()"></wd-list-input>
					</td>
					<td>
						<wd-typeahead name="Vegetation[{{i}}]" [(model)]="row.vegetation" (modelChange)="onVegetationChanged()" placement="bottom-left bottom-right top-left top-right"></wd-typeahead>
					</td>
					<td><wd-text-input name="Vegetations-Anteil[{{i}}]" class="text-right" [(model)]="row.haeufigkeit" (modelChange)="onVegetationChanged()"></wd-text-input></td>
					<td><button type="button" class="btn btn-danger btn-sm" (click)="onRemoveVegetationsZeile(i)"><i class="bi bi-trash"></i></button></td>
				</tr>
				<tr>
					<td colspan="4">
						<button style="width: 100%" type="button" class="btn btn-info btn-sm" (click)="onAddVegetationsZeile()"><i class="bi bi-plus"></i></button>
					</td>
				</tr>
			</tbody>
		</table>
		</div>

		<div class="spacer-sm"></div>

		<!-- Humusform, Vegetationsformengruppe und Bestand sind forstliche Bewertungen
		     und stehen nur bei einer Aufnahme nach SEA 95. Die Kartieranleitung hat ihre
		     eigene Humusform in der Profilkennzeichnung (Feld 63); zwei davon in einem
		     Punkt waeren eine Falle. Die Vegetationsaufnahme selbst wird bei beiden
		     Verfahren angeboten (Nutzer-Entscheidung 20.09.2026). -->
		@if (istSeaPunkt) {
			<!-- Humusform / Vegetationsformengruppe -->
			<div class="form-section-header" *ngIf="hatHumusForm(data) || hatVegetationsformengruppe(data)">{{ hatVegetationsformengruppe(data) ? 'Vegetationsformengruppe' : 'Humusform' }}</div>
			<div class="form-row" *ngIf="hatHumusForm(data) || hatVegetationsformengruppe(data)">
				<div class="form-input-cell multi no-scroll">
					<wd-an-typeahead *ngIf="hatHumusForm(data)" name="Humusform" [(model)]="data.header.humusform.aufnahmeFlaeche"></wd-an-typeahead>
					<wd-typeahead *ngIf="hatVegetationsformengruppe(data)" name="Vegetationsformengruppe" [(model)]="data.header.vegetationsformengruppe"></wd-typeahead>
				</div>
			</div>

			<!-- Bestand & Bemerkungen -->
			<div class="form-section-header">Bestand &amp; Bemerkungen</div>
			<bp-bestand-converter [data]="data"></bp-bestand-converter>
		} @else {
			<div class="form-section-header">Bemerkungen</div>
		}
		<!-- Keine graue Spalte davor (Nutzer-Entscheidung 02.10.2026): Mit SEA steht
		     „Bemerkungen" ueber dem Feld wie „Bestand-Text" darueber; ohne SEA nennt
		     die Ueberschrift das Feld schon, eine Beschriftung waere doppelt. -->
		<div class="form-row">
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [label]="istSeaPunkt ? 'Bemerkungen' : ''" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
